/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./superadmin.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./superadmin.component";
import * as i3 from "@ngrx/store";
import * as i4 from "../core/services/congito.wrapper.service";
var styles_SuperAdminComponent = [i0.styles];
var RenderType_SuperAdminComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_SuperAdminComponent, data: {} });
export { RenderType_SuperAdminComponent as RenderType_SuperAdminComponent };
export function View_SuperAdminComponent_0(_l) { return i1.ɵvid(0, [i1.ɵqud(402653184, 1, { containerRef: 0 }), (_l()(), i1.ɵeld(1, 0, [[1, 0], ["portalAdminReactContainer", 1]], null, 0, "div", [["class", "superadmin"]], null, null, null, null, null))], null, null); }
export function View_SuperAdminComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "portal-superadmin-component", [], null, null, null, View_SuperAdminComponent_0, RenderType_SuperAdminComponent)), i1.ɵdid(1, 4440064, null, 0, i2.SuperAdminComponent, [i3.Store, i4.CognitoWrapperService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var SuperAdminComponentNgFactory = i1.ɵccf("portal-superadmin-component", i2.SuperAdminComponent, View_SuperAdminComponent_Host_0, {}, {}, []);
export { SuperAdminComponentNgFactory as SuperAdminComponentNgFactory };
